import { Injectable } from '@angular/core';

export enum ButtonType {
  primary = 'primary',
  dashed = 'dashed',
  danger = 'danger',
  default = 'default',
  link = 'link',
  submit = 'submit',
  // 增加类型
  reset = 'reset',
  add = 'add'
}

export enum ButtonSize {
  normal = 'normal',
  small = 'small'
}

@Injectable({
  providedIn: 'root'
})
export class HdButtonService {

  constructor() { }

}
